import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import TagForm from "../form";

const UpdateTag = () => {
  const { tagId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Tag" />
      <div className="p-6 max-w-2xl">
        <TagForm tagId={tagId} />
      </div>
    </div>
  );
};

export default UpdateTag;
